<mat-list role="list" class="breadcrumb" >
    <ng-template ngFor [ngForOf]="breadcrumbs" let-last="last" let-first="first" let-breadcrumb>
        <mat-list-item class="mat-list-item-custom">
            <a *ngIf="!last" [class]="getCategory()" [routerLink]="generateLink(breadcrumb)">{{ breadcrumb.label }}</a>
            <p *ngIf="last">{{ breadcrumb.label }}</p>
        </mat-list-item>
        <mat-divider *ngIf="!last" vertical="true"></mat-divider>
    </ng-template>
</mat-list>
